<div id="productSelectorModal">
  <div class="rs-modal-heading">
    <h2 class="rs-modal-heading-title rs-has-subtit" id="selectModalTitle1">
      {{ 'product.selector.title' | translate }}
    </h2>
  </div>

  <div class="rs-modal-content">
    <fieldset class="rs-form-sbox">
      <legend class="show-for-sr">{{ 'product.selector.title' | translate }}</legend>
      <div class="rs-flex-row">
        <div
          class="small-12 medium-4 rs-flex-columns"
          *ngFor="let product of productsPagination; let i = index"
        >
          <div class="rs-sbox rs-sbox-with-extracontent">
            <input
              id="radioSelector{{ i }}"
              type="radio"
              (click)="selectProduct(product)"
              [(ngModel)]="selectedProduct"
              [value]="product"
              [disabled]="
                product.deepLinkStatus === DeepLinkStatus.DEEPLINK_OPTION_ORDERING_ALREADY_ACTIVE ||
                product.deepLinkStatus === DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE
              "
            />
            <label for="radioSelector{{ i }}">
              <span class="rs-sbox-maincontent">
                <span class="rs-sbox-check-header">
                  <span class="rs-sbox-check"></span>
                  <span class="rs-sbox-check-content">
                    <span class="rs-sbox-title">{{ product?.productDescription }}</span>
                    <span x-ms-format-detection="none"
                      >{{ product?.productDescription }}<br /><mprd-access-number-formatter
                        [accessNumber]="product?.accessNumber"
                        [plc]="product?.plc"
                      ></mprd-access-number-formatter
                    ></span>
                    <mprd-address
                      [address]="product?.installationAddress"
                      [showInOneLine]="true"
                    ></mprd-address>
                  </span>
                </span>
              </span>
              <span
                *ngIf="getDeepLinkStatusMessage(product)"
                class="rs-sbox-extracontent"
                [innerHTML]="getDeepLinkStatusMessage(product)"
              ></span>
              <span class="rs-sbox-extracontent" *ngIf="product?.options[0]?.price">
                <mprd-price [option]="product?.options[0]" amountClass="rs-price-s"></mprd-price>
              </span>
            </label>
          </div>
        </div>
      </div>
    </fieldset>

    <div *ngIf="products?.length > 6" class="rs-pagination">
      <div class="rs-navigation">
        <div
          class="rs-navigation-arrow rs-navigation-arrow-next"
          [ngClass]="{
            'rs-disabled': page >= pages.length - 1
          }"
        >
          <a class="rs-navigation-trigger" (click)="goToNextPage()">
            <i class="icon-Arrowbutton icon-lh icon-large"></i>
          </a>
        </div>
        <div
          class="rs-navigation-arrow rs-navigation-arrow-prev"
          [ngClass]="{ 'rs-disabled': page === 0 }"
        >
          <a class="rs-navigation-trigger" (click)="goToPreviousPage()">
            <i class="icon-Arrowbutton-left icon-lh icon-large"></i>
          </a>
        </div>
      </div>

      <div class="rs-pagination-counter">
        <div class="rs-form-item">
          <form [formGroup]="pageForm">
            <select
              id="ac-selectBox"
              class="rs-filled"
              formControlName="pageControl"
              (change)="onPageChange($any($event.target).value)"
            >
              <option *ngFor="let page of pages" [ngValue]="page">
                {{ page + 1 }}
              </option>
            </select>
          </form>
        </div>
        <span class="rs-pagination-counter-label">{{ ofNPages }}</span>
      </div>
    </div>
  </div>

  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <button (click)="confirm()" class="rs-btn rs-btn-nl-so" [disabled]="!selectedProduct">
          {{ 'product.selector.button.confirm' | translate }}
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button (click)="close()" class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal">
          {{ 'product.selector.button.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
